export default __webpack_public_path__ + "static/media/topicicon.1ab16966.svg";